// extracted by mini-css-extract-plugin
export default {"footer":"BladeFooter_footer__GKOcG","cancelButton":"BladeFooter_cancelButton__iwlKk"};